import { render, staticRenderFns } from "./AutoHelpForm.vue?vue&type=template&id=6f0fff46&scoped=true&"
import script from "./AutoHelpForm.vue?vue&type=script&lang=js&"
export * from "./AutoHelpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0fff46",
  null
  
)

export default component.exports